import type { ChipId, MineralKind, CreatureKind } from './config';
import type { WorldEventType } from './worldEvents';

export interface StageDef {
  id: string;
  number: number;
  name: string;
  levels: readonly [number, number];
  background: string;
  color: string;
  surfaceRatio: number;
  description: string;
  tip: string;
  signature: readonly MineralKind[];
  fieldTool: ChipId;
  recommended: readonly [ChipId, ChipId];
  events: readonly WorldEventType[];
  creatures: readonly CreatureKind[];
}

export const STAGES: readonly StageDef[] = [
  { id: 'woodland', surfaceRatio: 0.26, number: 1, name: '叶影林间', levels: [1, 2], background: '/assets/mining-valley.webp', color: '#71875b',
    description: '从木屋出发，寻找土壤里封存的小小阳光。', tip: '先抓近处暖铜和琥珀，再搬金块；鼹鼠瞄准矿物时可出钩赶走。',
    signature: ['amber','copper'], fieldTool: 'pocketClock', recommended: ['magnet', 'twinHook'], events: ['veinShift'], creatures:['mole'] },
  { id: 'crystal', surfaceRatio: 0.23, number: 2, name: '薄荷晶洞', levels: [3, 4], background: '/assets/stage-crystal.webp', color: '#6c9e99',
    description: '晶簇照亮石壁，珍珠藏在柔软的矿脉中。', tip: '深蓝尖晶体积小但值钱；注意晶甲虫，抓错重物可用剪绳。',
    signature: ['fluorite', 'pearl','sapphire'], fieldTool: 'lantern', recommended: ['blast', 'twinHook'], events: ['blackout', 'veinShift'], creatures:['beetle'] },
  { id: 'mushroom', surfaceRatio: 0.215, number: 3, name: '蘑菇花谷', levels: [5, 6], background: '/assets/stage-mushroom.webp', color: '#b98968',
    description: '蘑菇和莓红晶石一起，在暖土里慢慢生长。', tip: '暖日晶可接金色连击。避开蘑菇团子，护盾可防黏钩。',
    signature: ['garnet', 'fossil','sunstone'], fieldTool: 'seedPouch', recommended: ['twinHook', 'mossShield'], events: ['veinShift'], creatures:['slime','mole'] },
  { id: 'ruins', surfaceRatio: 0.235, number: 4, name: '古树遗迹', levels: [7, 8], background: '/assets/stage-ruins.webp', color: '#8b9671',
    description: '沿着古树的根，拾回时间留下的纹样。', tip: '黑曜石非常重。羽毛祝福配合绞盘可节约深层搬运时间。',
    signature: ['jade', 'fossil','obsidian'], fieldTool: 'surveyLens', recommended: ['gravityFlip', 'twinHook'], events: ['caveIn', 'blackout', 'veinShift'], creatures:['beetle','mole'] },
  { id: 'moon', surfaceRatio: 0.25, number: 5, name: '月光矿湖', levels: [9, 10], background: '/assets/stage-moon.webp', color: '#8995b5',
    description: '最后一盏灯点亮湖面，把星光装进回家的背包。', tip: '先观察月翼蝠的飞行路线。星愿留给晶洞石，加时合计有上限。',
    signature: ['moonstone', 'starGeode'], fieldTool: 'starElixir', recommended: ['gravityFlip', 'twinHook'], events: ['blackout', 'veinShift'], creatures:['bat','beetle','slime'] },
];

export function stageForLevel(level: number): StageDef {
  const safe = Number.isFinite(level) ? Math.max(1, Math.min(10, Math.floor(level))) : 1;
  return STAGES[Math.floor((safe - 1) / 2)];
}
